var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.applicationMaintenance)?_c('Maintenance'):(_vm.showSplash)?_c('div',{on:{"click":_vm.handleClick}},[_c('ComponentResolverMobile',{attrs:{"componentId":"SplashScreen"}})],1):_c('ComponentResolverMobile',{attrs:{"componentId":"AppSelector"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }